import React, { useState } from 'react';
import './responsive.css';
import Nav from './components/Nav';
import Hero from './components/Hero';
import Features from './components/Features';
import Comparison from './components/Comparison';
import HowItWorks from './components/HowItWorks';
import Industries from './components/Industries';
import Channels from './components/Channels';
import TechStack from './components/TechStack';
import Support from './components/Support';
import CTA from './components/CTA';
import Footer from './components/Footer';
import DemoModal from './components/DemoModal';

export default function App() {
  const [demoOpen, setDemoOpen] = useState(false);
  const openDemo  = () => setDemoOpen(true);
  const closeDemo = () => setDemoOpen(false);

  return (
    <div>
      <Nav onDemo={openDemo} />
      <Hero onDemo={openDemo} />
      <Features />
      <Comparison />
      <HowItWorks />
      <Industries />
      <Channels />
      <TechStack />
      <Support />
      <CTA onDemo={openDemo} />
      <Footer />
      <DemoModal open={demoOpen} onClose={closeDemo} />
    </div>
  );
}
